import { internal, template, Button } from '../../vendor/elix.js';
import ButtonMixin from './mixins/button-mixin.js';

class TpButton extends ButtonMixin(Button) {
  get [internal.template]() {
    return template.concat(
      super[internal.template]
    );
  }
}

export default TpButton;


